import React, { useState } from 'react';
import api from '../../../services/api';
import alertService from '../../../utils/alert';
import { Modal, Btn, INPUT, LABEL, fmtDate, errMsg } from './ui';

const ymd = (d) => { const x = new Date(d); return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`; };
const nextMonth = (d) => { const x = new Date(d); x.setMonth(x.getMonth() + 1); return ymd(x); };

// Repeat a bill (rent, subscriptions). Each period a new DRAFT copy appears
// for review — nothing is approved or paid automatically.
export default function RecurringModal({ bill, onClose, onSaved }) {
  const [recurrence, setRecurrence] = useState(bill.recurrence || 'monthly');
  const [nextBillDate, setNext] = useState(bill.nextBillDate ? ymd(bill.nextBillDate) : nextMonth(bill.billDate));
  const [endDate, setEnd] = useState(bill.recurringEndDate ? ymd(bill.recurringEndDate) : '');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/crm/purchases/bills/${bill._id}/recurring`, { recurrence, nextBillDate, endDate: endDate || undefined });
      alertService.success('Repeating bill set', `Next draft on ${fmtDate(data.bill.nextBillDate)}`);
      onSaved();
    } catch (e) { alertService.error('Could not save', errMsg(e)); } finally { setSaving(false); }
  };
  const stop = async () => {
    try { await api.delete(`/crm/purchases/bills/${bill._id}/recurring`); alertService.success('Stopped repeating'); onSaved(); } catch (e) { alertService.error('Could not stop', errMsg(e)); }
  };

  return (
    <Modal title={`Repeat ${bill.billNumber}`} onClose={onClose}
      footer={<>{bill.isRecurring && <Btn danger onClick={stop} className="mr-auto">Stop repeating</Btn>}<Btn onClick={onClose}>Cancel</Btn><Btn primary disabled={saving} onClick={save}>{saving ? 'Saving…' : 'Save'}</Btn></>}>
      <p className="text-[13px] text-[#706E6B]">A draft copy of this bill is created on each date, for you to check and approve. Nothing is posted or paid automatically.</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div>
          <label className={LABEL} htmlFor="rc-every">Every</label>
          <select id="rc-every" className={INPUT} value={recurrence} onChange={(e) => setRecurrence(e.target.value)}>
            <option value="weekly">Week</option><option value="monthly">Month</option><option value="quarterly">Quarter</option><option value="yearly">Year</option>
          </select>
        </div>
        <div><label className={LABEL} htmlFor="rc-next">Next bill on</label><input id="rc-next" type="date" className={INPUT} value={nextBillDate} onChange={(e) => setNext(e.target.value)} /></div>
        <div><label className={LABEL} htmlFor="rc-end">End (optional)</label><input id="rc-end" type="date" className={INPUT} value={endDate} onChange={(e) => setEnd(e.target.value)} /></div>
      </div>
    </Modal>
  );
}
